import { ConfirmDialog } from '@/components/common/ConfirmDialog';
import { useDeleteRcsTemplate } from '@/hooks/useRcs';

interface Props {
  templateId: string;
  name: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function RcsDeleteTemplateDialog({ templateId, name, open, onOpenChange }: Props) {
  const { mutate: remove, isPending } = useDeleteRcsTemplate();

  function handleConfirm() {
    remove(templateId, { onSuccess: () => onOpenChange(false) });
  }

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Excluir template RCS"
      description={`Tem certeza que deseja excluir "${name}"? Esta ação não pode ser desfeita.`}
      confirmLabel="Excluir"
      variant="destructive"
      onConfirm={handleConfirm}
      loading={isPending}
    />
  );
}
